import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBR from 'date-fns/locale/pt-BR';
import api from '../../services/api';
import { format, startOfDay, endOfDay } from 'date-fns';
import { toast } from 'react-toastify';

export default function FluxoCaixa() {
  const [movimentos, setMovimentos] = useState([]);
  const [resumo, setResumo] = useState({
    totalEntradas: 0,
    totalSaidas: 0,
    saldoTotal: 0
  });
  const [dataInicio, setDataInicio] = useState(startOfDay(new Date()));
  const [dataFim, setDataFim] = useState(endOfDay(new Date()));

  useEffect(() => {
    loadFluxoCaixa();
    loadResumo();
  }, [dataInicio, dataFim]);

  async function loadFluxoCaixa() {
    try {
      const response = await api.get('/fluxo-caixa', {
        params: {
          dataInicio: format(dataInicio, 'yyyy-MM-dd'),
          dataFim: format(dataFim, 'yyyy-MM-dd')
        }
      });
      setMovimentos(response.data);
    } catch (error) {
      toast.error('Erro ao carregar fluxo de caixa');
    }
  }

  async function loadResumo() {
    try {
      const response = await api.get('/fluxo-caixa/resumo', {
        params: {
          dataInicio: format(dataInicio, 'yyyy-MM-dd'),
          dataFim: format(dataFim, 'yyyy-MM-dd')
        }
      });
      setResumo(response.data);
    } catch (error) {
      toast.error('Erro ao carregar resumo do fluxo de caixa');
    }
  }

  return (
    <Box sx={{ p: { xs: 1, md: 2 }, pl: { xs: 1, md: 1.5 } }}>
      <Grid container spacing={2} style={{ marginBottom: 20, marginTop: 20 }}>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            Fluxo de Caixa
          </Typography>
        </Grid>

        {/* Filtro por Data */}
        <Grid item xs={12}>
          <Paper style={{ padding: 16, marginBottom: 16 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={5}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    label="Data Início"
                    value={dataInicio}
                    onChange={(newValue) => setDataInicio(startOfDay(newValue))}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={5}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    label="Data Fim"
                    value={dataFim}
                    onChange={(newValue) => setDataFim(endOfDay(newValue))}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    loadFluxoCaixa();
                    loadResumo();
                  }}
                >
                  Filtrar
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Cards de Resumo */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="primary">
                Total de Entradas
              </Typography>
              <Typography variant="h4">
                R$ {Number(resumo.totalEntradas).toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="error">
                Total de Saídas
              </Typography>
              <Typography variant="h4">
                R$ {Number(resumo.totalSaidas).toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="primary">
                Saldo Total
              </Typography>
              <Typography variant="h4" color={resumo.saldoTotal >= 0 ? 'primary' : 'error'}>
                R$ {Number(resumo.saldoTotal).toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Data</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>CPF</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Valor</TableCell>
              <TableCell>Observação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {movimentos.map((movimento) => (
              <TableRow 
                key={movimento.id}
                sx={{
                  backgroundColor: movimento.tipo === 'entrada' ? '#e8f5e9' : '#ffebee'
                }}
              >
                <TableCell>
                  {format(new Date(movimento.data_movimento), 'dd/MM/yyyy HH:mm')}
                </TableCell>
                <TableCell>{movimento.cliente_nome || '-'}</TableCell>
                <TableCell>{movimento.cliente_cpf || '-'}</TableCell>
                <TableCell>{movimento.descricao}</TableCell>
                <TableCell>R$ {Number(movimento.valor).toFixed(2)}</TableCell>
                <TableCell>{movimento.observacao}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}